<template>
  <div class="post-wall-card-content">
    <!-- 一般文字 -->
    <div ref="generalWord" :class="['general-word', isNeedReadMoreBtn ? 'need-more' : '']" v-html="decodeContent"></div>
    <!-- 是否要顯示更多按鈕(貼文高度過高時顯示) -->
    <div v-if="isNeedReadMoreBtn" class="reed-more-btn" @click="isNeedReadMoreBtn = false">顯示更多</div>
    <!-- 圖片 -->
    <PostPictureSwipe :items="pictureArrays"></PostPictureSwipe>
    <!-- url 解析的 metadata -->
    <template v-if="postCardContentData.imgSet.length < 1">
      <UrlMetadata v-if="checkHaveUrl" :url="checkHaveUrl" :content="decodeContent"></UrlMetadata>
    </template>
    <!-- 分享別人貼文的 UI (檢查 0:沒有分享貼文 1:友圈內分享貼文 2:透過 API分享的貼文) -->
    <!-- 有可能分享而來的原始貼文已被刪除，因此需再判斷 ShareObj.PostId 是否存在?-->
    <div v-if="postCardContentData.HasSharePost === 1 && postCardContentData.ShareObj.PostId" class="share-card">
      <PostWallCard :postData="postCardContentData.ShareObj"></PostWallCard>
    </div>
    <!-- 分享的原始貼文已被原作者刪除 -->
    <div class="q-my-lg" v-if="postCardContentData.HasSharePost === 1 && !postCardContentData.ShareObj.PostId">原始貼文已被刪除</div>
  </div>
</template>

<script>
import PostPictureSwipe from '@/components/PostWall/PostPictureSwipe';
import UrlMetadata from '@/components/PostWall/UrlMetadata';

export default {
  name: 'PostWallCardContent',
  props: ['postCardContentData'],
  components: {
    PostPictureSwipe,
    UrlMetadata,
    // 組件間的循環引用(PostWallCard 裡面又有再引用 PostWallCard)
    PostWallCard: () => import('./PostWallCard')
  },
  data() {
    return {
      // 是否要顯示更多按鈕
      isNeedReadMoreBtn: false,
      // url 正則表達式
      urlRegex: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g
    };
  },
  computed: {
    // 將編碼過的內容解碼 並判斷 url 類型的給予 <a> 以利點擊可連結跳轉頁面
    decodeContent() {
      let decodeContent = decodeURI(this.postCardContentData.Content);
      let newContent = decodeContent;
      // 忽略空白內容
      if (decodeContent === '<p><br></p>' || decodeContent === '<span><br></span>') {
        return '';
      }

      // 正則表達式找url
      let url = decodeContent.match(this.urlRegex);
      let isAlreadyATag = decodeContent.match(`<a href=`);

      // 如果內容本身已帶有 a tag 就不再做 replace 為 a tag
      if (url && !isAlreadyATag) {
        newContent = decodeContent.replace(url[0], `<a href="${url[0]}">${url[0]}</a>`);
      }
      return newContent;
    },
    // 圖片
    pictureArrays() {
      let arrays = this.postCardContentData.imgSet.map((item, index) => {
        let data = {
          id: index,
          src: `${process.env.VUE_APP_PICTURE_PATH}${item}`,
          thumbnail: `${process.env.VUE_APP_PICTURE_PATH}${item}`
        };
        return data;
      });
      return arrays;
    },
    // 判斷是否有 url (含有 http:// 或是 https://)
    checkHaveUrl() {
      // 後端有時會存下解析完的 url 的 data
      if (this.postCardContentData.ShareObj) {
        if (this.postCardContentData.ShareObj.ShareURL) {
          return this.postCardContentData.ShareObj.ShareURL;
        }
      }

      let decodeContent = decodeURI(this.postCardContentData.Content);
      // 正則表達式找url
      if (decodeContent.match(this.urlRegex) !== null) {
        return decodeContent.match(this.urlRegex)[0];
      }
      return false;
    }
  },
  methods: {
    // 檢查貼文文字內容高度有無超過 95px，有則需要隱藏高度並顯示 '顯示更多' 按鈕
    checkNeedReadMoreBtn() {
      let wordHeight = this.$refs.generalWord.offsetHeight;
      if (wordHeight > 95) {
        this.isNeedReadMoreBtn = true;
      }
    }
  },
  mounted() {
    // 要呼叫 this.$refs. 必須等 dom 物件畫完後才可呼叫
    this.checkNeedReadMoreBtn();
  }
};
</script>

<style lang="scss" scoped>
.post-wall-card-content {
  margin-top: 15px;
}

.general-word {
  width: 100%;
  word-break: break-word;

  &.need-more {
    height: 95px;
    overflow: hidden;
  }
}

.reed-more-btn {
  color: $LaleGray8;
  font-size: 18px;
  text-align: center;
  position: relative;
  margin-top: -80px;
  padding-top: 80px;
  margin-bottom: 15px;
  background-image: linear-gradient(-180deg, rgba(255, 255, 255, 0) 0%, #fff 70%);
}
</style>
